import script from "./DeleteConversationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteConversationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteConversationDialog.vue?vue&type=style&index=0&id=d390250e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d390250e"]])

export default __exports__